import moment from 'moment';
export const getHoursAndMinutes = (timestamp, noSeconds = false) => {
    if (!timestamp)
        return undefined;
    const duration = moment.duration(timestamp);
    const totalHours = Math.floor(duration.asHours());
    const hours = String(totalHours).padStart(2, '0');
    const minutes = String(duration.minutes()).padStart(2, '0');
    const seconds = String(duration.seconds()).padStart(2, '0');
    if (noSeconds) {
        return `${hours}:${minutes}`;
    }
    return `${hours}:${minutes}:${seconds}`;
};
